import { useContext } from "react";
import {
  DialerGlobalContext,
  DialerGlobalContextI,
} from "@/context/dialer-global";

export const useDialerGlobalContext = (): DialerGlobalContextI =>
  useContext(DialerGlobalContext);
